$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

(function ($) {
    "use strict";

    // =======Preloader========>>>>>
    let preloaderTimeout = 4500;
    setTimeout(function () {
        $("body").addClass("loaded");
    }, preloaderTimeout);
    // =======Preloader========>>>>>

    // =======Sticky-header========>>>>>
    $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();
        if (scroll < 50) {
            $(".sticky-navbar").removeClass("sticky");
            $(".back-to-top").hide();
        } else {
            $(".sticky-navbar").addClass("sticky");
            $(".back-to-top").show();
        }
    });
    // =======Sticky-header========>>>>>

    // =======Social share========>>>>>
    if ($(".share-link").length > 0) {
        $(".share-link").on("click", function (event) {
            event.preventDefault();
            let iconList = $(".social-icons-list");
            iconList.toggleClass("social-icons-toggle");
        });
    }
    // =======Social share========>>>>>

    // =======CounterUp JS-Odometer========>>>>>
    if ($(".odometer").length > 0) {
        $(window).on("scroll", function () {
            function winScrollPosition() {
                var scrollPos = $(window).scrollTop(),
                    winHeight = $(window).height();
                var scrollPosition = Math.round(scrollPos + winHeight / 0.07);
                return scrollPosition;
            }
            var elemOffset = $(".odometer").offset().top;
            if (elemOffset < winScrollPosition()) {
                setTimeout(function () {
                    $(".odometer").each(function () {
                        $(this).html($(this).data("count-to"));
                    });
                }, preloaderTimeout + 200);
            }
        });
    }

    // =======CounterUp JS-Odometer========>>>>>

    // =======Circle========>>>>>
    const text = document.querySelector(".rotate-text p");
    if (text) {
        text.innerHTML = text.innerText
            .split("")
            .map((char, i) => `<span style="transform:rotate(${i * 9.6}deg)">${char}</span>`)
            .join("");
    }

    const text2 = document.querySelector(".rotate-text2 p");
    if (text2) {
        text2.innerHTML = text2.innerText
            .split("")
            .map((char, i) => `<span style="transform:rotate(${i * 9.6}deg)">${char}</span>`)
            .join("");
    }

    const text3 = document.querySelector(".rotate-text3 p");
    if (text3) {
        text3.innerHTML = text3.innerText
            .split("")
            .map((char, i) => `<span style="transform:rotate(${i * 9.6}deg)">${char}</span>`)
            .join("");
    }

    // =======Circle========>>>>>

    // =======Swiper .merchandise-swiper========>>>>>
    if (typeof Swiper !== 'undefined' && $(".merchandise-swiper").length > 0) {
        new Swiper(".merchandise-swiper", {
            loop: true,
            grabCursor: true,
            spaceBetween: 30,
            breakpoints: {
                420: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                },
                1500: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                },
            },

            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
    // =======Swiper .merchandise-swiper========>>>>>

    // =========Button(Increse-Decrese)=========>>>>>
    var buttonPlus = $(".plus-icon");
    var buttonMinus = $(".dash-icon");

    var incrementPlus = buttonPlus.click(function () {
        var $n = $(this).parent(".ticket-amounts").find(".input-number");
        $n.val(Number($n.val()) + 1);
    });

    var incrementMinus = buttonMinus.click(function () {
        var $n = $(this).parent(".ticket-amounts").find(".input-number");
        var amount = Number($n.val());
        if (amount > 1) {
            $n.val(amount - 1);
        }
    });
    // =========Button(Increse-Decrese)=========>>>>>

    // =========Ticket-Section Radio-Input=========>>>>>
    $("input:radio:checked").parent().addClass("radio-checked-bg border-transparent");
    $("input:radio").click(function () {
        $("input:not(:checked)").parent().removeClass("radio-checked-bg border-transparent");
        $("input:checked").parent().addClass("radio-checked-bg border-transparent");
    });
    // =========Ticket-Section Radio-Input=========>>>>>

    // =======Magnific-PopUp========>>>>>
    if (typeof $.fn.magnificPopup !== 'undefined') {
        $(".image-link").magnificPopup({
            type: "image",
            gallery: {
                enabled: true,
            },
            zoom: {
                enabled: true,
                duration: 300, // don't foget to change the duration also in CSS
                opener: function (element) {
                    return element.find("img");
                },
            },
        });

        // Video popup
        $(".video-popup-link").magnificPopup({
            disableOn: 200,
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
        });

        // Map popup
        $(".map-popup").magnificPopup({
            type: "image",
            closeOnContentClick: true,
            image: {
                verticalFit: true,
            },
        });
    }

    // =======Magnific-PopUp========>>>>>

    // Initialize WOW.js if available
    if (typeof WOW !== 'undefined') {
        new WOW().init();
    }

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    $("#contact_form_template").on("click", "#submit_contact_form", function () {
        console.log("test");
        processContactForm();
    });

    function processContactForm() {
        $.ajax({
            type: "POST",
            url: config.routes.contactProcess,
            data: {
                name: $("input#name").val(),
                surname: $("input#surname").val(),
                email: $("input#email").val(),
                message: $("textarea#message").val(),
            },
            success: function (response) {
                $("#contact_form_template").html(response.response_message);
            },
            error: function (response) {
                if (response.status == 422) {
                    // display errors on each form field
                    $(".input__error-text").remove();

                    $.each(response.responseJSON.errors, function (i, error) {
                        $("input[name=" + i + "]").addClass("error");
                        $("#contact_form_template").find('[data-name="message"]').addClass("error");
                        var el = $("#" + i);
                        el.after($('<p class="input__error-text">' + error[0] + "</p>"));
                    });
                }
            },
        });
    }

    $("#merch_form_template").on("click", "#submit_merch_form", function (e) {
        e.preventDefault();
        processMerchForm();
    });

    function processMerchForm() {
        $.ajax({
            type: "POST",
            url: config.routes.merchProcess,
            data: {
                name: $("input#name").val(),
                surname: $("input#surname").val(),
                address: $("input#address").val(),
                city: $("input#city").val(),
                psc: $("input#psc").val(),
                phone: $("input#phone").val(),
                email: $("input#email").val(),
                trickoBiele: $("input#tricko-biele").val(),
                trickoZlte: $("input#tricko-zlte").val(),
                mikinaZlta: $("input#mikina-zlta").val(),
                mikinaCierna: $("input#mikina-cierna").val(),
                pero: $("input#pero").val(),
                snurka: $("input#snurka").val(),
                taska: $("input#taska").val(),
                pohar: $("input#pohar").val(),
                uterak: $("input#uterak").val(),
                okuliare: $("input#okuliare").val(),
                klobuk: $("input#klobuk").val(),
                lehatko: $("input#lehatko").val(),
                note: $("textarea#note").val(),
                mathcaptcha: $("input#mathcaptcha").val(),
            },
            success: function (response) {
                $("#merch_form_template").html(response.response_message);
            },
            error: function (response) {
                if (response.status == 422) {
                    // display errors on each form field
                    $(".input__error-text").remove();

                    $.each(response.responseJSON.errors, function (i, error) {
                        $("input[name=" + i + "]").addClass("error");
                        var el = $("#" + i);
                        el.after($('<p class="input__error-text">' + error[0] + "</p>"));
                    });
                }
            },
        });
    }

    // First screen of lineup photos. Raise this number to show more before the button.
    var lineupVisibleCount = 11;
    var $lineupSlides = $("#ucinkujuci .swiper-slide");
    $lineupSlides.removeClass("hidden-lineup");
    $lineupSlides.slice(lineupVisibleCount).addClass("hidden-lineup");
    if ($("#ucinkujuci .swiper-slide.hidden-lineup").length === 0) {
        $("#load-more-images").hide();
    }

    $("#load-more-images").on("click", function () {
        $("#ucinkujuci .swiper-slide.hidden-lineup")
            .slice(0, lineupVisibleCount)
            .removeClass("hidden-lineup");

        if ($("#ucinkujuci .swiper-slide.hidden-lineup").length === 0) {
            $("#load-more-images").hide();
        }
    });

    // Initialize OWL Carousel if available
    if (typeof $.fn.owlCarousel !== 'undefined') {
        $(".owl-carousel").owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            dots: false,
            items: 1,
            autoplay: false,
            touchDrag: false,
            smartSpeed: 2000,
            speed: 20000,
            navText: ['<i class="fa fa-arrow-left" aria-hidden="true"></i>', '<i class="fa fa-arrow-right" aria-hidden="true"></i>'],
        });

        // Add accessible labels to navigation buttons
        $(".owl-carousel .owl-prev").attr("aria-label", "Predchádzajúci obrázok");
        $(".owl-carousel .owl-next").attr("aria-label", "Ďalší obrázok");
    }

    $("#vote_form_template").on("click", "#submit_vote_form", function (e) {
        e.preventDefault();
        processVoteForm();
    });

    let base64Hash = "";

    document.addEventListener("DOMContentLoaded", async () => {
        // Extract WebGL data
        const getWebGLData = () => {
            const canvas = document.createElement("canvas");
            const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            if (!gl)
                return {
                    vendor: "unknown",
                    renderer: "unknown",
                };

            const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
            const vendor = debugInfo ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) : "unknown";
            const renderer = debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : "unknown";

            return {
                vendor,
                renderer,
            };
        };

        const { vendor, renderer } = getWebGLData();

        // Extract WebGL rendered picture data
        const getWebGLRenderedPictureHash = () => {
            const canvas = document.createElement("canvas");
            const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            if (!gl) return "unknown";

            // Set canvas size
            canvas.width = 256;
            canvas.height = 256;

            // Clear the canvas with a specific color
            gl.clearColor(0.5, 0.5, 0.5, 1.0); // Gray color
            gl.clear(gl.COLOR_BUFFER_BIT);

            // Read pixel data
            const pixels = new Uint8Array(canvas.width * canvas.height * 4); // RGBA
            gl.readPixels(0, 0, canvas.width, canvas.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);

            // Generate a hash from the pixel data
            let hash = 0;
            for (let i = 0; i < pixels.length; i++) {
                hash = (hash * 31 + pixels[i]) >>> 0; // Simple hash function
            }
            return hash.toString();
        };

        const renderedPictureHash = getWebGLRenderedPictureHash();

        // Get the user agent
        const userAgent = navigator.userAgent;

        // Get the list of plugins
        const getPluginsList = () => {
            if (!navigator.plugins) return "unknown";
            return Array.from(navigator.plugins)
                .map((plugin) => plugin.name)
                .join(", ");
        };

        const pluginsList = getPluginsList();

        // Get content language
        const contentLanguage = navigator.language || "unknown";

        // Get count of navigator properties
        const navigatorPropertiesCount = Object.keys(navigator).length;

        // Combine all values into a single string
        const combinedData = JSON.stringify({
            webgl_vendor: vendor,
            webgl_renderer: renderer,
            webgl_picture_hash: renderedPictureHash,
            user_agent: userAgent,
            // plugins_list: pluginsList,
            content_language: contentLanguage,
            navigator_properties_count: navigatorPropertiesCount,
        });

        // Generate a Base64 hash
        base64Hash = btoa(combinedData);
    });

    function processVoteForm() {
        const bandId = $("#band_id").val();
        const newBandName = $("#new_band_name").val();

        $.ajax({
            url: config.routes.vote,

            method: "POST",
            data: {
                band_id: bandId,
                new_band_name: bandId === "new" ? newBandName : null,
                captcha_question_id: $("input#captcha_question_id").val(),
                captcha_question: $("input#captcha_question").val(),
                email: $("input#email").val(),
                lodenica: base64Hash,
            },
            success: function (response) {
                $(".input__error-text").remove();
                showInfoMessage(response.response_message);

                // if (response.action != "danger") {
                    loadResults();
                // }
            },
            error: function (response) {
                if (response.status == 422) {
                    $(".input__error-text").remove();
                    // display errors on each form field

                    $.each(response.responseJSON.errors, function (i, error) {
                        console.log(i);
                        $("input[name=" + i + "]").addClass("error");
                        $("#contact_form_template")
                            .find('[data-name="message"]')
                            .addClass("error");
                        var el = $("#" + i);
                        console.log(el);
                        el.after(
                            $(
                                '<p class="input__error-text"><i class="fa fa-exclamation-circle" aria-hidden="true"></i>' +
                                error[0] +
                                "</p>"
                            )
                        );
                    });
                }
            },
        });
    }

    function loadResults() {
        $.ajax({
            url: config.routes.getResults,
            method: "GET",
            success: function (response) {
                $("#results").html(response);
            },
        });
    }

    $("#band_id").on("select2:select", function (e) {
        if (e.params.data.id === "new") {
            $("#new_band_container").show();
        } else {
            $("#new_band_container").hide();
        }
    });

    setTimeout(function () {
        $("#info_messages .alert").removeClass("show");
    }, 5000);

    function showInfoMessage(message, time = 3000) {
        if (message) {
            $("#info_messages").html(message);
        }

        setTimeout(function () {
            $("#info_messages .alert").removeClass("show");
        }, time);
    }

    // Initialize Select2 if available
    if (typeof $.fn.select2 !== 'undefined') {
        $(".select-2").select2({
            theme: "bootstrap-5",
            height: "91px",
        });
    }
})(jQuery);
